var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keyboard-shortcuts',{attrs:{"show-shortcuts-obj":_vm.showShortcutsObj,"line-data-sets":_vm.lineDataSets}})}
var staticRenderFns = []

export { render, staticRenderFns }